import { render, staticRenderFns } from "./SkuIntegrationForm.vue?vue&type=template&id=edda864a"
import script from "./SkuIntegrationForm.vue?vue&type=script&lang=js"
export * from "./SkuIntegrationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports